import React from 'react';
import { getAPIData, getAPIDataParams } from '../utils/apiFunction';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from "@mui/material/TextField";

const CustomerSelect = (props) => {
    const [farmr, setFarmr] = React.useState([]);
    const [value, setValue] = React.useState(props.state);
    const [inputValue, setInputValue] = React.useState('');
    const filterVals = (lists) => {
        if (!Array.isArray(lists)) { setFarmr([]); return; }
        // Normalize incoming objects to ensure myobid exists (even if blank)
        const normalized = lists.map(l => ({
            id: l.id ?? l.Id,
            name: l.name ?? l.Name ?? '',
            myobid: l.myobid ?? l.Myobid ?? l.myobId ?? ''
        }));
        normalized.sort((a,b)=> a.name > b.name ? 1 : -1);
        setFarmr(normalized);
    };
    // When the list loads or frmrId changes, attempt to select matching record
    React.useEffect(() => {
        if (props.frmrId) {
            const est = farmr.find(dr => String(dr.id) === String(props.frmrId));
            if (est) {
                props.setState(est);
                setValue(est);
            }
        }
    }, [farmr, props.frmrId]);

    // Keep internal value aligned if parent passes a new state object
    React.useEffect(() => {
        if (props.state && (!value || String(props.state.id) !== String(value.id))) {
            setValue(props.state);
        }
    }, [props.state]);
    React.useEffect(() => {
        getAPIData('/Customers/Get', filterVals);
    }, [])
    return (<Autocomplete
        value={value}
        disabled={props.disabled}
        onChange={(event, newValue) => {
            props.setState(newValue);
            setValue(newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue);
        }}
        getOptionLabel={(option) => {
            if (!option) return '';
            const idPart = option.myobid ? option.myobid : '';
            return idPart ? (idPart + ' - ' + (option.name || '')) : (option.name || '');
        }}
        isOptionEqualToValue={(o,v) => o && v && String(o.id) === String(v.id)}
        disablePortal
        id="farmrbox"
        options={farmr}
        sx={props.widthAuto?{width:'auto'}:{ width: 300 }}
        renderInput={(params) => <TextField {...params} label="Customer" />}
    />);



}
export default CustomerSelect;